class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.testimonials-slider__track');
    this.slides = Array.from(this.querySelectorAll('.testimonials-slider__slide'));
    this.prevButton = this.querySelector('.testimonials-slider__arrow--prev');
    this.nextButton = this.querySelector('.testimonials-slider__arrow--next');
    this.dots = Array.from(this.querySelectorAll('.testimonials-slider__dot'));
    this.currentIndex = 0;

    this.slidesPerView = this.getSlidesPerView();

    this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
    this.nextButton.addEventListener('click', this.onNextClick.bind(this));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.currentIndex = parseInt(dot.dataset.index, 10);
        this.update();
      });
    });

    window.addEventListener('resize', this.onResize.bind(this));

    this.update();
  }

  getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 749) return 1;
    if (width <= 989) return 2;
    return parseInt(this.dataset.slidesDesktop, 10) || 3;
  }

  onResize() {
    const newSlidesPerView = this.getSlidesPerView();
    if (newSlidesPerView !== this.slidesPerView) {
      this.slidesPerView = newSlidesPerView;
      this.currentIndex = 0;
      this.update();
    }
  }

  get maxIndex() {
    return Math.max(0, this.slides.length - this.slidesPerView);
  }

  onPrevClick() {
    this.currentIndex = Math.max(0, this.currentIndex - 1);
    this.update();
  }

  onNextClick() {
    this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1);
    this.update();
  }

  update() {
    if (!this.slides.length) return;

    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const offset = this.currentIndex * (slideWidth + gap);

    this.track.style.transform = `translateX(-${offset}px)`;

    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex >= this.maxIndex;

    this.dots.forEach((dot, index) => {
      dot.classList.toggle('testimonials-slider__dot--active', index === this.currentIndex);
    });
  }
}

customElements.define('testimonials-slider', TestimonialsSlider);